import React, { Component } from 'react'
import { connect } from 'react-redux'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

class AppErrorDialogComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showDialog: false,
			errors: [],
		}
	}

	handleClose = () => {
		this.setState({showDialog: false});
	};

	componentWillReceiveProps(props) {
		this.setState({
			showDialog: props.show,
			errors: props.errors,
		});
	}

	componentWillMount() {

	}

	componentDidMount() {

	}

	render() {
		const actions = [
			<FlatButton
				label="Oplossen"
				primary={true}
				onClick={this.handleClose}
			/>,
		];

		return (
			<div>
				<Dialog
					actions={actions}
					modal={false}
					open={this.state.showDialog}
					onRequestClose={this.handleClose}
				>
					<h2>Oeps, even Apeldoorn bellen:</h2>
					<ul>
						{
							this.state.errors.map( ( error, key ) => {
								return (
									<li key={key}>{error}</li>
								)
							})
						}
					</ul>
				</Dialog>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {}
}

export default connect(mapStateToProps)(AppErrorDialogComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/errorDialog.js